import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { Card } from 'reactstrap';
import { ClassroomBox } from './parts/ClassroomBox';
import { ClassroomCalendarLoader } from './parts/ClassroomLoader';
import { Calendar } from './parts/Calendar';
import { EventTypesLoader } from './parts/EventTypesLoader';

export function ClassroomCalendar() {
  const { classroomId } = useParams<{
    classroomId: string;
  }>();
  const [calendarDate, setCalendarDate] = useState<string | null>(null);

  return (
    <>
      <Card className="mx-3 p-4">
        <EventTypesLoader>
          <ClassroomCalendarLoader classroomId={classroomId}>
            {({ data }) => (
              <>
                <ClassroomBox
                  classRoomInfo={{
                    name: data.classroom.name,
                    code: data.classroom.code,
                    type: data.classroom.type.name,
                    school: data.classroom.campus.name,
                  }}
                />
                <Calendar
                  data={data}
                  calendarDate={calendarDate}
                  setCalendarDate={setCalendarDate}
                />
              </>
            )}
          </ClassroomCalendarLoader>
        </EventTypesLoader>
      </Card>
    </>
  );
}
